import { Box, Typography, InputBase } from "@mui/material";
import theme from "@/theme";
import { styles } from "./stylesCustomLink";

interface CustomLink {
  title: string;
  url: string;
}

interface AddCustomLinkProps {
  links: CustomLink[];
  onChange: (links: CustomLink[]) => void;
  isValidUrl?: boolean | boolean[];
}

const AddCustomLink = ({ links, onChange, isValidUrl = true }: AddCustomLinkProps) => {
  const handleChange = (index: number, field: "title" | "url", value: string) => {
    const updatedLinks = links.map((link, i) => (i === index ? { ...link, [field]: value } : link));
    onChange(updatedLinks);
  };

  const isUrlValid = (index: number): boolean => {
    if (typeof isValidUrl === "boolean") return isValidUrl;
    return isValidUrl[index] ?? true;
  };

  const displayLinks = links.length > 0 ? links : [{ title: "", url: "" }];

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: "14px", mt: "12px" }}>
      <Typography sx={styles.heading}>Add custom link</Typography>

      {displayLinks.map((link, index) => (
        <Box
          key={index}
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "6px",
            mt: index !== 0 ? "20px" : 0,
          }}
        >
          <Box sx={{ ...styles.inputBox, ...styles.firstInputBox }}>
            <InputBase
              placeholder="Add URL Title..."
              fullWidth
              sx={styles.firstInput}
              value={link.title}
              onChange={(e) => handleChange(index, "title", e.target.value)}
            />
          </Box>

          <Typography sx={styles.subLabel}>This text will show instead of the URL.</Typography>

          <Box sx={styles.inputBox}>
            <Typography sx={styles.urlLabel}>URL</Typography>
            <Typography sx={styles.divider}>|</Typography>
            <InputBase
              placeholder="http://example.com"
              fullWidth
              sx={{
                ...styles.urlInput,
                "& .MuiInputBase-input": {
                  color: isUrlValid(index) ? theme.palette.custom.mainBlue : "#2A2D31",
                  textDecoration: isUrlValid(index) ? "underline" : "none",
                  textDecorationStyle: "solid",
                  textDecorationColor: theme.palette.custom.mainBlue,
                  textDecorationThickness: "0.5px",
                  textUnderlineOffset: "2px",
                },
              }}
              value={link.url}
              onChange={(e) => handleChange(index, "url", e.target.value)}
            />
          </Box>
        </Box>
      ))}
    </Box>
  );
};

export default AddCustomLink;
